
import Vue from "vue";

export default Vue.extend({
  name: "page",
  methods: {
    closePage() {
      KNB.ready(() => {
        KNB.closePage({});
      });
    }
  },
  data() {
    return {
      head: "版本过低",
      message: "请先升级APP到最新版本，再来尝试",
      imgUrl:
          "//vfile.meituan.net/scarlett/a881406362184c228b9db739a8bc4e427924.png"
    };
  },
  created() {
    KNB.ready(() => {
      KNB.setLLButton({
        icon: "H5_Back",
        handle: () => {
          KNB.closePage({});
        }
      });
    });
  }
});
